import React, { Suspense } from 'react';
import { Route, Switch } from "react-router-dom";
import Auth from "../hoc/auth";
// pages for this product
import LandingPage from "./views/LandingPage/LandingPage.js";
import LoginPage from "./views/LoginPage/LoginPage.js";
import RegisterPage from "./views/RegisterPage/RegisterPage.js";
import UploadProductPage from './views/UploadProductPage/UploadProductPage'
import DetailProductPage from './views/DetailProductPage/DetailProductPage';
import CartPage from './views/CartPage/CartPage';
import HistoryPage from './views/HistoryPage/HistoryPage';
import MyProductPage from './views/MyProductPage/MyProductPage';
import OthersPage from './views/OthersPage/OthersPage';
import AddFriendPage from './views/AddFriendPage/AddFriendPage';
import FriendsPage from './views/FriendsPage/FriendsPage';
import TermsPage from './views/TermsPage/TermsPage';
import JoinPage1 from './views/RegisterPage/JoinPage1';
import JoinPage2 from './views/RegisterPage/JoinPage2';
import JoinPage3 from './views/RegisterPage/JoinPage3';
import MembersPage from './views/MembersPage/MembersPage';
import ProfilePage from './views/ProfilePage/ProfilePage';
import ChatDetailPage from './views/ChatPage/ChatDetailPage';
import ChatListPage from './views/ChatListPage/ChatListPage';
import RouteChangeTracker from './utils/RouteChangeTracker';
import ForgotPasswordPage from './views/ForgotPasswordPage/ForgotPasswordPage';
import TestPage from './views/TermsPage/TestPage';

function App() {
  return (
    <Suspense fallback={(<div>Loading...</div>)}>
      <div className='contents'>
        <Switch>
          <Route exact path="/" component={Auth(LandingPage, true, true)} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/join" component={JoinPage1} />
          <Route exact path="/join2" component={JoinPage2} />
          <Route exact path="/join3" component={JoinPage3} />
          <Route exact path="/register" component={Auth(RegisterPage, true, false, false, true)} />
          <Route exact path="/terms" component={Auth(TermsPage, true, false, false, true)} />
          <Route exact path="/body-profile" component={Auth(TestPage, true, false, false, true)} />
          <Route exact path="/product/upload" component={Auth(UploadProductPage, true)} />
          <Route exact path="/product/:productId" component={Auth(DetailProductPage, true)} />
          <Route exact path="/user/cart" component={Auth(CartPage, true)} />
          <Route exact path="/history" component={Auth(HistoryPage, true)} />
          <Route exact path="/equip_list_mine" component={Auth(MyProductPage, true)} />
          <Route exact path="/others" component={Auth(OthersPage, true)} />
          {/* <Route exact path="/friends" component={Auth(FriendsPage, true)} /> */}
          <Route exact path="/members" component={Auth(MembersPage, true, true)} />
          <Route exact path="/requestFriend" component={Auth(AddFriendPage, true)} />
          <Route exact path="/profile" component={Auth(ProfilePage, true, true)} />
          <Route exact path="/chat_list" component={Auth(ChatListPage, true, true)} />
          <Route exact path="/chat_detail" component={Auth(ChatDetailPage, true)} />
          <Route exact path="/forgot_password" component={Auth(ForgotPasswordPage, true, false, false, true)} />
          <RouteChangeTracker />
        </Switch>
      </div>
    </Suspense>
  );
}

export default App;
